module.exports = __webpack_public_path__ + "img/scervice-11.9d193e5d.gif";